import {useLayoutEffect, useState} from "react";
import {useExamPageNavigate} from "../../../pages/exam/common/navigation/useExamPageNavigate";
import {ExamPageSection} from "../../../pages/exam/common/navigation/routes";
import {problemsetApiSlice} from "../../../store/api/problemsetApiSlice";
import {useAppDispatch} from "../../../store/hooks";

const useDialogControl = () => {
  const dispatch = useAppDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const examPageNavigate = useExamPageNavigate();

  useLayoutEffect(() => {
    handleDialogOpen();
    return () => {
      dispatch(problemsetApiSlice.util.invalidateTags(["QuestionList"]));
      setIsDialogOpen(false);
    };
  }, []);

  const handleDialogClose = () => {
    if (isDialogOpen === false) return;
    examPageNavigate(ExamPageSection.PROBLEM_SET, undefined);
  };
  const handleDialogOpen = () => {
    if (isDialogOpen === true) return;
    setIsDialogOpen(true);
  };
  const handleDialogCleanUp = () => {};

  return {
    isDialogOpen,
    handleDialogClose,
    handleDialogCleanUp,
  };
};

export default useDialogControl;
